export const enumToText = (enumValue: string) => {
  return enumValue
    .split("_")
    .map((word) =>
      word === "OF" ? "of" : word[0] + word.slice(1).toLowerCase(),
    )
    .join(" ")
    .replace("Usd", "USD");
};
